<div [className]="goalChild ? 'padding_x_25' : ''">
  <table class="table table-bordered w-100 mb-0">
     <ng-container *ngIf="!isMobile">
    <thead>
      <tr class="header_row">
        <td *ngIf="columnsActive?.column1active" class="action_column">
        {{config?.column1title ? config?.column1title : 'Action'}}
      </td>
      <td *ngIf="columnsActive?.column2active" class="description_column">
        {{config?.column2title ? config?.column2title : 'Description'}}
      </td>
      <td *ngIf="columnsActive?.column3active" class="tscb_column">
        <p>{{config?.column3title ? config?.column3title : 'Timeline'}}</p>
      </td>
      <td *ngIf="columnsActive?.column4active" class="tscb_column">
        <p>{{config?.column4title ? config?.column4title : 'Status'}}</p>
      </td>
      <td *ngIf="columnsActive?.column5active" class="tscb_column">
        <p>{{config?.column5title ? config?.column5title : 'Co Benefits'}}</p>
      </td>
    </tr>
    </thead>

    <tbody>
      <tr *ngFor="let action of actions">
        <td *ngIf="columnsActive?.column1active"><p class="font-weight-bold" [style.color]="color">
          {{action.title}}
        </p></td>
        <td *ngIf="columnsActive?.column2active"><span class="description_span">
          <app-dynamic-content
            [contentId]="'new-action-taxonomy-action-desc'"
            [htmlContent]="action.description">
          </app-dynamic-content>
        </span></td>
        <td *ngIf="columnsActive?.column3active"><p class="font-weight-bold" [style.color]="color">{{action.timeline}}</p></td>
        <td *ngIf="columnsActive?.column4active" class="status_cell">
          <div class="d-flex justify-content-center" *ngIf="!action.simpleTextStatus">
            <span class="status-cintainer waves-light"
                  [matTooltipPosition]="'above'" (mouseenter)="applyStatusStyles()" [matTooltip]="action?.status?.value ? action?.status?.value : 'Awaiting resources'">
            <span class="status" [style.background-color]="
            action?.status?.value == 'Complete' ? '#35C13B'
          : action.status?.value == 'In Progress' ? '#2492D6'
          : '#FFCE00'" [style.width]="
          action?.status?.value == 'Complete' ? '100%'
            : action?.status?.value == 'In Progress' ? '70%'
            : '30%'"></span>
          </span>
          </div>
          <span class="simple_text" *ngIf="action.simpleTextStatus">
            <app-dynamic-content
              [contentId]="'new-action-taxonomy-action-simple-text'"
              [htmlContent]="action.simpleTextStatus">
            </app-dynamic-content>
          </span>
        </td>
          <td role="gridcell" class="co-benefits" *ngIf="columnsActive?.column5active">
            <span *ngIf="!action.simpleTextCoBenefits && getCoBenefitImage(coBenefit)">
              <ng-container *ngFor="let coBenefit of action.coBenefits">
                <img *ngIf="getCoBenefitImage(coBenefit)" [src]="getCoBenefitImage(coBenefit)" [alt]="getCoBenefitImageAlt(coBenefit.title)" [matTooltip]="getCoBenefitImageTitle(coBenefit)" [matTooltipPosition]="'above'" class="cobenefits_icon" (mouseenter)="applyCoBenefitsStyles()">
              </ng-container>
            </span>
            <span class="simple_text" *ngIf="action.simpleTextCoBenefits">
              <app-dynamic-content
                [contentId]="'new-action-taxonomy-action-simple-text-benefits'"
                [htmlContent]="action.simpleTextCoBenefits">
              </app-dynamic-content>
            </span>
          </td>
      </tr>
    </tbody>
  </ng-container>

<!-- Mobile version -->
<ng-container *ngIf="isMobile">
  <thead>
    <tr class="mobile_row">
      <td *ngIf="columnsActive?.column1active" class="action_title_cell">
        <p>{{config?.column1title ? config?.column1title : 'Action'}}</p>
    </td>
    <td *ngIf="columnsActive?.column2active">
      <span>{{config?.column2title ? config?.column2title : 'Description'}}</span>
    </td>
  </tr>
</thead>
<tbody *ngFor="let action of actions">
  <tr>
    <td *ngIf="columnsActive?.column1active" class="action_title_cell">
      <p [style.color]="color">
        {{action.title}}
      </p>
    </td>
    <td *ngIf="columnsActive?.column2active">
      <app-dynamic-content
        [contentId]="'new-action-taxonomy-action-desc'"
        [htmlContent]="action.description">
      </app-dynamic-content>
    </td>
  </tr>
  <tr>
    <td *ngIf="columnsActive?.column3active" colspan="2" class="p-0">
      <div class="d-flex">
        <div class="w-50 d-flex justify-content-center align-items-center border_right p-3">
          {{config?.column3title ? config?.column3title : 'Timeline'}}
        </div>
        <div class="w-50 d-flex justify-content-center align-items-center p-3">
          <p [style.color]="color">{{action.timeline}}</p>
        </div>
      </div>
    </td>
  </tr>
  <tr *ngIf="columnsActive?.column4active">
      <td colspan="2" class="p-0">
        <div class="d-flex">
          <div class="w-50 d-flex justify-content-center align-items-center border_right p-3">
            {{config?.column4title ? config?.column4title : 'Status'}}
          </div>
          <div class="w-50 d-flex justify-content-center align-items-center p-3">
            <span *ngIf="!action.simpleTextStatus">
              <span class="status-cintainer waves-light">
              <span class="status" [style.background-color]="
              action?.status?.value == 'Complete' ? '#35C13B'
              : action.status?.value == 'In Progress' ? '#2492D6'
              : '#FFCE00'" [style.width]="
              action?.status?.value == 'Complete' ? '100%'
              : action?.status?.value == 'In Progress' ? '70%'
              : '30%'"></span>
            </span>
            </span>
            <span class="simple_text" *ngIf="action.simpleTextStatus">
              <app-dynamic-content
                [contentId]="'new-action-taxonomy-action-simple-text'"
                [htmlContent]="action.simpleTextStatus">
              </app-dynamic-content>
            </span>
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="2" class="p-0">
        <div class="d-flex">
          <div class="w-50 d-flex justify-content-center align-items-center border_right p-3">
            Co Benefits
          </div>
          <div class="w-50 d-flex justify-content-center align-items-center p-3 co-benefits" role="gridcell">
            <span *ngIf="!action.simpleTextCoBenefits">
              <img *ngFor="let coBenefit of action.coBenefits" [src]="getCoBenefitImage(coBenefit)" [alt]="getCoBenefitImageAlt(coBenefit)" class="cobenefits_icon">
            </span>
            <span class="simple_text" *ngIf="action.simpleTextCoBenefits">
              <app-dynamic-content
                [contentId]="'new-action-taxonomy-action-simple-text-benefits'"
                [htmlContent]="action.simpleTextCoBenefits">
              </app-dynamic-content>
            </span>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</ng-container>
  </table>
</div>
